var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tree"},[_c('ul',{staticClass:"tree-list"},[_c('node-tree',{attrs:{"node":_vm.treeData,"action":_vm.action},on:{"confirm":_vm.updatedNode}}),_c('br'),_c('a',{staticClass:"add-padding",attrs:{"href":"#"},on:{"click":function($event){return _vm.addChild(_vm.treeData.children)}}},[_vm._v("+ Add Criteria")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }